import { render, staticRenderFns } from "./CommunityHealthInfoDetail.vue?vue&type=template&id=4dc726d7&scoped=true"
import script from "./CommunityHealthInfoDetail.vue?vue&type=script&lang=js"
export * from "./CommunityHealthInfoDetail.vue?vue&type=script&lang=js"
import style0 from "./CommunityHealthInfoDetail.vue?vue&type=style&index=0&id=4dc726d7&prod&scoped=true&lang=css"
import style1 from "./CommunityHealthInfoDetail.vue?vue&type=style&index=1&id=4dc726d7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc726d7",
  null
  
)

export default component.exports